export const headerContentTypeJson = { 'Content-Type': 'application/json' }
